
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { StudentSignupListAPI } from "@/common/api/competitionManage/studentSignupList";

import { excuteDownloadExport2Excel } from "@/common/xlsx";

// import { util } from "vue/types/umd";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
// import ZlSelect from "@/components/third-custom-components/select";

// import ZlOption from "@/components/third-custom-components/option";

import {
  shareConfirmOptions,
  shareShopType2ch
} from '@/common/config'

// 暴露的API 列表
export const pageApiList = getPageAPIs(StudentSignupListAPI);

console.log(pageApiList, 'pageApiList')

const defaultForm = {
  phone: "", // 手机号

  receipt_code: "", // 券码

  shop_name: "", // 店铺名称

  receipt_order_id: "", // 订单编号

  time: []
}

const defaultForms = {
  // name: "",
  // origin_price: "",
  // sale_price: "",
  // shop_type: 1,
  // expired_days: "",
  // meituanId: "",
  // timeDuration: "",
  // pool_table_category_ids: [],
  // coupons_time_id: "",
  // venue_id: "",
  // venue: {
  //   id: "",
  //   name: "",
  // },
  // singleMaxCountType: '0',
  // shop_id: "",
  // maxLimitCount: ''
};


// const couponDialogTitle2ch: any = {
//   "new-coupon": "新增时长卡",
//   "edit-coupon": "编辑时长卡",
// };

// 最大有效期
// const maxExpiredDays = 9999;

// // 最大时长 单位分钟
// const maxTimeDuration = 24 * 60;

// // coupon 卡券分属类别
// const couponShopType2ch: any = [
//   ...shareShopType2ch
// ]

// 3为美团7为抖音
const useCouponTypeName2ch: string[] = ['', '', '', '美团', '', '', '', '抖音']

// 性别1男2女
const gender2ch: string[] = ['未知', '男', '女']

@Component({
  filters: {
    // showCouponShopTypeName(shop_type: number) {
    //   return couponShopType2ch[shop_type] || ''
    // }
    showUseCouponType2ch(source: number) {
      return useCouponTypeName2ch[source] || '未知'
    },

    showGenderName(gender: number) {
      return gender2ch[gender]
    }
  },
  components: {
    // ZlSelect,
    // ZlOption,
  },
})
export default class CouponsManage extends Vue {
  private form: any = {
    // couponId: "",
    shop_name: "",
    shop_contact_mobile: "",
    date_time: "",
    time: [],
    // startDate: "",
    // endDate: "",
  };
  private forms: any = {
    // maxType: "0",
    // ...defaultForms
  };

  private deepLoopUtil: any = {};

  // private merchantApi: any;

  private studentSignupListApi = new StudentSignupListAPI();
  // private couponTimeDurationAPI = new CouponTimeDurationManageAPI();
  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    // this.searchVenuePageOption = {
    //   ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
    // };

    // this.merchantApi = new MerchantApi();
  }

  private created(): void {
    this.getStudentSignupRecords();

    // this.refreshCouponTimeDurations();

    // this.refreshTableClass();
  }
  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };
    // this.form = new Util().clearObject(this.form);
    // this.$router.replace("/orderList");
    this.getStudentSignupRecords();
  }

  private resetLeagueData():void{
    this.$confirm(`确定重置联赛数据吗?`, "", {
      ...shareConfirmOptions,
    }).then(() => {
      this.studentSignupListApi.resetStudentRecords(
          {},
          () => {
            this.$message.success("重置成功");
            this.getStudentSignupRecords();
          },
          () => {}
      );
    });
  }

  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getStudentSignupRecords();
  }

  private tableData: any[] = [];


  private formLabelWidth: string = "100px";

  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.getStudentSignupRecords();
  }

  //获取优惠券列表
  private getStudentSignupRecords(): void {
    this.studentSignupListApi.getStudentSignupRecords(
      { ...this.getCouponVertifyCodeRecordParams() },
      (res: any) => {
        // res.data.list
        this.tableData = res.data.list;
        this.tablePage.page = res.data.page;
        this.tablePage.prepage = res.data.prepage;
        // this.tablePage.totalPage = res.data.total;
        this.tablePage.count = res.data.count;
      },
      () => {}
    );
  }

  private getCouponVertifyCodeRecordParams(mode = "all"): any {
    const params: any = {};

    const form = this.form;

    const tablePage = this.tablePage;

    const { page, prepage } = tablePage;

    const {
      shop_contact_mobile,
      // receipt_code,
      shop_name,
      date_time,
      // time
    } = form;

     if (shop_name) {
      params.shop_name = shop_name
    }

    if (shop_contact_mobile) {
      params.shop_contact_mobile = shop_contact_mobile
    }

    if (date_time) {
      params.date_time = date_time
    }

 

    // if (Array.isArray(time) && time.length === 2) {
    //   const [startDate, endDate] = time;

    //   const startTime = Util.dateTimeUtilnohms(startDate);
    //   const endTime = Util.dateTimeUtilnohms(endDate);

    //   params.start_date = startTime;

    //   params.end_date = endTime;
    // }

    // if (
    //   mode == "exportExcel" &&
    //   !(params.start_date && params.end_date)
    // ) {
    //   this.$message.error("请选择日期导出数据");
    //   return null;
    // }

    if (mode === "all") {
      params.page = page;

      params.limit = prepage;

    }

    return params;
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 订单字段名 文案对应关系
  private orderExcelList2ch: any = {
    shop_name: "店铺",
    shop_contact_mobile: "手机号",
    "__stu_info": "学员信息",
    // "__stu2": "学员信息2",
    // "__stu3": "学员信息3",
    created_at: "提交时间"
  };
  // 订单Excel 表头的先后顺序
  private orderExcelSortList: string[] = [
    "shop_name",
    "shop_contact_mobile",
    "__stu_info",
    // "__stu2",
    // "__stu3",
    "created_at"
  ];

  // 点击导出excel 表格
  private handleDownloadExcel() {
    const params = this.getCouponVertifyCodeRecordParams("exportExcel");

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.studentSignupListApi.exportStudentSignupRecords(
      params,
      (res: any) => {
        const {
          // start_date,
          // end_date,
          date_time
        } = params || {};

        const filename = `学生报名信息列表 ${date_time || ''}.xlsx`;
        const { data } = res || {};

        const { list: originList } = data || {};

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const {
                // user_type,
                // price,
                // refunded_price,
                // device,
                // pay_type,
                // daytime_minute,
                // night_minute,
                // goods_detail,
                // status
                student_info = []
              } = item || {};

              const student_info_strs = student_info.filter((item: any) => !!item.full_name).map((item: any) => {
                const {
                  full_name,
                  sex,
                  mobile,
                  academy
                } = item || {}

                const info_str = `姓名：${full_name} 性别：${gender2ch[sex]} 手机号：${mobile} 就读院校：${academy}`

                return info_str
              })

              console.log(student_info_strs, 'student_info_strs')

              const newItem = {
                ...(item || {}),
                // device_name: orderDeviceType2ch[device],
                // pay_type_name: payType2ch[pay_type],
                // total_miniute: daytime_minute + night_minute,
                // actual_price: price - refunded_price || "",
                // user_level_type_name: userLevel2ch[user_type],
                // __status_name: orderStatus2Ch[status],
                // __good_details: goods_detail.map((goods: any, index: number) => `${index + 1}、${ goods.name }x${ goods.num }  ¥${ goods.price }`).join('; \t')
                __stu_info: '',
              };

              newItem.__stu_info = student_info_strs.map((info_str: string, index: number) => `学生${index + 1}--- ${info_str}`).join('\n')

              // if (student_info_strs[0]) {
              //   newItem.__stu1 = student_info_strs[0]
              // }

              // if (student_info_strs[1]) {
              //   newItem.__stu2 = student_info_strs[1]
              // }

              // if (student_info_strs[2]) {
              //   newItem.__stu3 = student_info_strs[2]
              // }

              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const orderExcelSortList = this.orderExcelSortList;

          const orderExcelList2ch = this.orderExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            orderExcelSortList,
            orderExcelList2ch
          );

          // console.log(newList, "newList");

          // console.log(excelJSONData, "excelJSONData");

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("没有可导出的信息");
        }

    

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */

  private selectPage: any = {
    page: 1,
    prepage: 200,
    totalPage: 0,
    count: 0,
  };
}
